/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
//Plan type and rebate program
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_DISPUTE_AMOUNT_DISPLAY = 'REFRESH_DISPUTE_AMOUNT_DISPLAY';
export const IS_LOADING = 'IS_LOADING';
export const SET_SELECTED_INPUT_UNALLOCATED = 'SET_SELECTED_INPUT_UNALLOCATED';
export const SET_MANUFACTURERS_LIST_DIISPUTE_AMOUNT =
  'SET_MANUFACTURERS_LIST_DIISPUTE_AMOUNT';
export const SET_COMPUTED_FIELDS = 'SET_COMPUTED_FIELDS';
export const SET_BALANCE_THREAD = 'SET_BALANCE_THREAD';
export const SET_AMOUNT_NDC_DETAILS = 'SET_AMOUNT_NDC_DETAILS';
export const SET_NDC_CODES = 'SET_NDC_CODES';

export const GET_EARLIEST_QTR_DRUG_VALUE = 'GET_EARLIEST_QTR_DRUG_VALUE';
export const GET_DRAMS_INVOICE_START_QUARTER_VALUE =
  'GET_DRAMS_INVOICE_START_QUARTER_VALUE';
export const SET_AMOUNT_NDC_DETAILS_EXPORT_ALL =
  'SET_AMOUNT_NDC_DETAILS_EXPORT_ALL';
export const REFRESH_DISPUTE_AMOUNT = 'REFRESH_DISPUTE_AMOUNT';
export const SET_AMOUNT_NDC_CODES_EXPORT_ALL =
  'SET_AMOUNT_NDC_CODES_EXPORT_ALL';
export const SET_PAGINATION_INDEX_DISPUTE_AMOUNTS =
  'SET_PAGINATION_INDEX_DISPUTE_AMOUNTS';
